<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>

          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Pantalla para revisar solicitudes de creación o extensión de crédito.
                Consulta los detalles, agrega comentarios y aprueba o rechaza cada solicitud.
                Puedes modificar el monto aprobado, registrar motivos y mantener historial de cambios.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Solicitud de crédito
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Lista, procesa y valida las <b>solicitudes de crédito</b> previa aprobación.
        </div>
      </div>
      <!-- Header -->
      <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
          <app-status-filters [selectedStatuses]="selectedStatuses" [selectedERPStatuses]="selectedERPStatuses"
            [showRequestCredit]="true" [selectedStatusRequestCredit]="selectedStatusRequestCredit"
            [showStatus]="[statusEnum.ACTIVE,statusEnum.ORDER_APPROVED,statusEnum.ORDER_REJECTED]"
            [showERPStatus]="[0,1,2,3,4,5,6]" (selectionFilterApply)="getList()">
          </app-status-filters>
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Sol. de Nuevos Clientes</div> -->
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <button mat-icon-button color="primary" (click)="openCreateModal()" matTooltip="Nuevo Registro">
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button>
          <button mat-icon-button color="primary" [matMenuTriggerFor]="filterMenu" matTooltip="Glosario">
            <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
          </button>
          <mat-menu #filterMenu="matMenu">
            <button mat-menu-item [matMenuTriggerFor]="statusMenu">
              <span>Estado</span>
            </button>
            <button mat-menu-item [matMenuTriggerFor]="statusERPMenu">
              <span>Estados ERP</span>
            </button>
          </mat-menu>
          <mat-menu #statusMenu="matMenu">
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_outline:check-circle" style="color: #9f9f3d"></mat-icon>
              <span>Pendiente</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_outline:check-circle" style="color: #008000;"></mat-icon>
              <span>Aprobado</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_outline:x-circle" color="warn"></mat-icon>
              <span>Rechazado</span>
            </button>
          </mat-menu>
          <mat-menu #statusERPMenu="matMenu">
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:clock" style="color: rgb(233, 124, 61)"></mat-icon>
              <span>Pendiente envío a ERP</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:exclamation-triangle" style="color: rgb(141, 19, 19)"></mat-icon>
              <span>Error enviando a ERP</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:exclamation-triangle" style="color: rgb(255, 0, 0)"></mat-icon>
              <span>Error en ERP</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:document-arrow-up" style="color: rgb(65, 106, 218)"></mat-icon>
              <span>Enviado a ERP</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:document-arrow-down" style="color: rgb(236, 199, 58)"></mat-icon>
              <span>Recibido por ERP</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:clock" style="color: rgb(148, 46, 139)"></mat-icon>
              <span>Mod. pendiente de replicar</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:document-check" style="color: rgb(9, 133, 50)"></mat-icon>
              <span>Creado en ERP</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>

    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort
              (matSortChange)="changeSort($event)" matSortDisableClear multiTemplateDataRows>

              <ng-container matColumnDef="det">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row" class="tight-cell">
                  <button class="h-7 min-h-7 min-w-10 px-2 leading-6" mat-icon-button (click)="toggleDetails(row)"
                    style="margin-left: 10px;">
                    <mat-icon class="icon-size-5" [svgIcon]="selectedCredit?._id === row._id
                      ? 'heroicons_solid:chevron-up' : 'heroicons_solid:chevron-down' "></mat-icon>
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="statusId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                <td mat-cell *matCellDef="let row">
                  <mat-icon *ngIf="row.statusId == statusEnum.ACTIVE" svgIcon="heroicons_outline:check-circle"
                    matTooltip="Pendiente" style="color:#9f9f3d; cursor: pointer;"></mat-icon>
                  <mat-icon *ngIf="row.statusId == statusEnum.ORDER_APPROVED" svgIcon="heroicons_outline:check-circle"
                    matTooltip="Aprobado" style="color:#008000; cursor: pointer;"></mat-icon>
                  <mat-icon *ngIf="row.statusId == statusEnum.ORDER_REJECTED" svgIcon="heroicons_outline:x-circle"
                    matTooltip="Rechazado" style="color:#ff0000; cursor: pointer;"></mat-icon>
                </td>
              </ng-container>

              <ng-container matColumnDef="statusERP">
                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                <td mat-cell *matCellDef="let row">
                  <mat-icon *ngIf="row.statusERP == 0 || !(row.statusERP)" svgIcon="heroicons_solid:clock"
                    matTooltip="Pendiente envío a ERP" style="color:rgb(233, 124, 61); cursor: pointer;"></mat-icon>
                  <mat-icon *ngIf="row.statusERP == 1" svgIcon="heroicons_solid:document-arrow-up"
                    matTooltip="Enviado a ERP" style="color:rgb(65, 106, 218); cursor: pointer;"></mat-icon>
                  <mat-icon *ngIf="row.statusERP == 2" svgIcon="heroicons_solid:document-arrow-down"
                    matTooltip="Recibido por ERP" style="color:rgb(236, 199, 58); cursor: pointer;"></mat-icon>
                  <mat-icon *ngIf="row.statusERP == 3" svgIcon="heroicons_solid:document-check"
                    matTooltip="Creado en ERP" style="color:rgb(9, 133, 50); cursor: pointer;"></mat-icon>
                  <mat-icon *ngIf="row.statusERP == 4" svgIcon="heroicons_solid:exclamation-triangle"
                    matTooltip="Error enviando a ERP" style="color:rgb(141, 19, 19); cursor: pointer;"></mat-icon>
                  <mat-icon *ngIf="row.statusERP == 5" svgIcon="heroicons_solid:clock"
                    matTooltip="Mod. pendiente de replicar"
                    style="color:rgb(148, 46, 139); cursor: pointer;"></mat-icon>
                  <mat-icon *ngIf="row.statusERP == 6" svgIcon="heroicons_solid:exclamation-triangle"
                    matTooltip="Error en ERP" style="color:rgb(255, 0, 0); cursor: pointer;"></mat-icon>
                </td>
              </ng-container>

              <!-- Ruta -->
              <ng-container matColumnDef="subRoute">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Ruta</th>
                <td mat-cell *matCellDef="let row" class="text-sm leading-tight">
                  <div *ngIf="getCode(row.subRoute) as code">
                    <b style="font-size: 12px;">{{ code }}</b>
                  </div>
                  {{ row.subRoute?.name }}
                </td>
              </ng-container>

              <ng-container matColumnDef="businessPartner">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Socio de Negocio</th>
                <td mat-cell *matCellDef="let row" class="text-sm leading-tight">
                  <div *ngIf="getCode(row.businessPartner) as code">
                    <b class="f-10">{{ code }}</b>
                  </div>
                  <div class="max-w-[150px] overflow-hidden text-ellipsis whitespace-nowrap"
                    title="{{ row?.businessPartner?.name }}">
                    {{ row?.businessPartner?.name }}
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="user">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Usuario</th>
                <td mat-cell *matCellDef="let row" class="text-sm leading-tight">
                  {{ row?.user?.username }}
                </td>
              </ng-container>

              <!-- Date-->
              <ng-container matColumnDef="createdAt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="items-center">Fecha <br> y Hora</th>
                <td mat-cell *matCellDef="let row" class="text-sm leading-tight">
                  {{ row.createdAt | FormatDateHour: true }}
                </td>
              </ng-container>

              <ng-container matColumnDef="sellerComments">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Cmt. del vendedor</th>
                <td mat-cell *matCellDef="let row" class="text-sm leading-tight"
                  [matTooltip]="row.sellerComments?.length > 30 ? row.sellerComments : null">
                  {{ row.sellerComments?.length > 30 ? (row.sellerComments | slice:0:30) + '…' : row.sellerComments }}
                </td>
              </ng-container>

              <ng-container matColumnDef="amountCreditRequested">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Monto deseado {{ 'code' | companyCurrency: true }}</th>
                <td mat-cell *matCellDef="let row" class="text-sm">
                  {{ row.amountCreditRequested | number: '1.2-2'}}
                </td>
              </ng-container>

              <ng-container matColumnDef="amountCreditApproved">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Monto aprobado {{ 'code' | companyCurrency: true }}</th>
                <td mat-cell *matCellDef="let row" class="text-sm">
                  {{ row.amountCreditApproved | number: '1.2-2'}}
                </td>
              </ng-container>

              <ng-container matColumnDef="isExtension">
                <th mat-header-cell *matHeaderCellDef class="text-center">Tipo</th>
                <td mat-cell *matCellDef="let row">
                  <span
                    class="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-bold uppercase tracking-wide"
                    [ngClass]="{
                      'bg-blue-200 text-blue-800 dark:bg-blue-600 dark:text-blue-50': !row.isExtension,
                      'bg-orange-200 text-orange-800 dark:bg-orange-600 dark:text-orange-50': row.isExtension,
                    }">
                    <p>{{ (row?.isExtension ? 'Extensión' : 'Solicitud') ?? " - " }}</p>
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="images">
                <th mat-header-cell *matHeaderCellDef>Imágenes</th>
                <td mat-cell *matCellDef="let row" class="text-center">
                  <button mat-icon-button color="primary" matTooltip="Ver Imágenes"
                    [disabled]="!row.attachments || row.attachments.length === 0" (click)="openGalleryModal(row)">
                    <mat-icon svgIcon="heroicons_outline:photo"></mat-icon>
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left">
                </th>
                <td mat-cell *matCellDef="let row" class="px-6 py-3 text-left">
                  <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionMenu="matMenu">
                    @if(row.statusId === statusEnum.ACTIVE){
                    <button mat-menu-item (click)="openApprove(row)">
                      <mat-icon svgIcon="heroicons_outline:check-circle"></mat-icon>
                      <span>Aprobar/Rechazar</span>
                    </button>
                    }
                    <button mat-menu-item (click)="openDeleteDialog(row)">
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      <span>Eliminar Registro</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
                  <tr *ngIf="selectedCredit?._id === row._id" class="details-row">
                    <td [attr.colspan]="displayedColumns.length">
                      <ng-container *ngTemplateOutlet="rowDetailsTemplate; context: { $implicit: row }"></ng-container>
                    </td>
                  </tr>
              </ng-container>

              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"
                class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>

              <!-- Fila Principal -->
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"
                [class.table-expanded-row]="selectedCredit?._id === row._id"></tr>

              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="table-detail-row"></tr>
            </table>
          </div>
          <div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo
            sentimos, no hay registros para mostrar.
          </div>
        </div>

        <!-- Paginación debería asignar valor a this.pageSize-->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
            [pageSize]="pageSize" (page)="changePage($event)"></mat-paginator>
        </div>
      </div>
    </div>
  </div>

  <ng-template #rowDetailsTemplate let-business>
    <div class="overflow-hidden">
      <div class="flex">
        <form class="flex w-full flex-col">
          <div class="flex flex-col py-4 px-2 sm:flex-row">
            <div class="container flex-auto flex-col">
              <div class="p-2 flex w-full">
                <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table [dataSource]="dataSourceDetail"
                  style="table-layout: fixed; width: 100%;" matSort>
                  <ng-container matColumnDef="approvalDate">
                    <th mat-header-cell *matHeaderCellDef>Fecha y Hora</th>
                    <td mat-cell *matCellDef="let detail" class="text-sm">
                      {{ detail.approvalDate | FormatDateHour: true }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="username">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Usuario</th>
                    <td mat-cell *matCellDef="let detail" class="text-sm leading-tight">
                      <b>{{detail?.approvalUser?.username}}</b> <br>
                      {{detail?.approvalUser?.email}}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="approve">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Estado</th>
                    <td mat-cell *matCellDef="let detail">
                      <span
                        class="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-bold uppercase tracking-wide"
                        [ngClass]="{
                          'bg-red-200 text-red-800 dark:bg-red-600 dark:text-red-50': detail.reasonRejection, 
                          'bg-green-200 text-green-800 dark:bg-green-600 dark:text-green-50': !detail.reasonRejection,}">
                        <span class="whitespace-nowrap leading-relaxed">
                          {{detail.approvalDate === undefined ? '' : detail.reasonRejection ? 'Rechazado' : 'Aprobado'}}
                        </span>
                      </span>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="approvalComments">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Comentario</th>
                    <td mat-cell *matCellDef="let detail" class="text-sm">
                      {{detail?.approvalComments}}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="reasonRejection">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Motivo de Rechazo</th>
                    <td mat-cell *matCellDef="let detail" class="text-sm">
                      {{detail?.reasonRejection?.name}}
                    </td>
                  </ng-container>

                  <!-- Header Row -->
                  <tr mat-header-row *matHeaderRowDef="displayedColumnsDetail" class="bg-gray-100 dark:bg-gray-900">
                  </tr>
                  <!-- Fila principal -->
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsDetail;" class="border-b"></tr>
                </table>
              </div>
              <div *ngIf="this.dataSourceDetail.data.length === 0" class="p-8 text-center text-1xl sm:p-10">Lo sentimos,
                no hay registros para mostrar.
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </ng-template>

  <!-- Modal Agregar y Editar -->
  <ng-template #actionModal>
    <h2 mat-dialog-title class="text-lg font-bold mb-1">{{ (this.id == null ? 'Nuevo' : 'Editar')}} Registro</h2>
    <mat-dialog-content class="modal-content">
      <form [formGroup]="creditRequestForm">
        <div class="grid grid-cols-1 gap-y-2 gap-x-4">
          <app-form-section title="Organización y Compañía" icon="business" iconColor="purple">
            <div class="grid grid-cols-2 gap-y-2 gap-x-4 items-center">
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Compañía</mat-label>
                <mat-select formControlName="companyId" name="company" required>
                  @for (company of companyFilterList; track company) {
                  <mat-option [value]="company._id">
                    {{ company.name }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Socios de Negocio</mat-label>
                <mat-select formControlName="businessPartnerId" name="businessPartnerId"
                  (selectionChange)="onBusinessPartnerChange()" required>
                  <mat-option>
                    <ngx-mat-select-search [(ngModel)]="searchBusiness" [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="changueOptionsBusiness($event)" placeholderLabel="Buscar socio..."
                      noEntriesFoundLabel="No se encontraron resultados">
                    </ngx-mat-select-search>
                  </mat-option>
                  @for (business of businessPartnerList; track business) {
                  <mat-option [value]="business._id">
                    <b *ngIf="getCode(business) as code">{{ code }} - </b>{{ business.name }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </app-form-section>

          <app-form-section title="Información Básica" icon="info" iconColor="blue">
            <div class="grid grid-cols-2 gap-y-2 gap-x-4">
              @if(creditRequestForm.get('creditLimit') && creditRequestForm.get('creditLimit')?.value > 0){
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Límite de crédito aprobado</mat-label>
                <input matInput type="text" formControlName="creditLimit" name="creditLimit" mask="separator.0"
                  thousandSeparator="," readonly>
              </mat-form-field>
              }

              <mat-form-field appearance="fill"
                [ngClass]="creditRequestForm.get('creditLimit')?.value ? 'col-span-1' : 'col-span-2'">
                <mat-label>Crédito solicitado</mat-label>
                <input matInput type="text" formControlName="amountCreditRequested" name="amountCreditRequested"
                  mask="separator.0" thousandSeparator="," required>
                <mat-error *ngIf="creditRequestForm.get('amountCreditRequested')?.hasError('belowMinLimit')">
                  El monto solicitado no puede ser menor al límite de crédito.
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="fill" class="col-span-2">
                <mat-label>Comentario</mat-label>
                <input matInput formControlName="sellerComments" name="sellerComments">
              </mat-form-field>
            </div>
          </app-form-section>

          @if(this.id == null) {
          <app-form-section title="Imágenes Adjuntas" icon="paperclip" iconColor="orange">
            <input type="file" multiple (change)="onFilesSelected($event)"
              class="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 p-2"
              accept="image/*" /> @if(selectedFiles.length > 0){
            @if(tooManyFilesAttempted){
            <div class="mt-2 text-sm text-red-500">
              El máximo de imágenes es 3. (Se han seleccionado las primeras {{ selectedFiles.length }} imágenes)
            </div>
            } @else {
            <div class="mt-2 text-sm text-gray-500">
              Imágenes seleccionadas: {{ selectedFiles.length }} de 3
            </div>
            }
            } @else {
            <div class="mt-2 text-sm text-red-500">
              Debes seleccionar al menos una imágen (máximo 3).
            </div>
            }

            @if(previewUrls.length > 0) {
            <div class="mt-4 flex flex-wrap gap-3">
              @for (url of previewUrls; track $index) {
              <div class="relative w-24 h-24 border rounded overflow-hidden">
                <img [src]="url" alt="Preview {{$index + 1}}" class="object-cover w-full h-full" />
              </div>
              }
            </div>
            }
          </app-form-section>
          }

        </div>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions class="modal-actions flex justify-end">
      <button mat-button mat-dialog-close class="align-left">Cancelar</button>
      <button mat-raised-button color="primary" (click)="onSubmit()"
        [disabled]="!creditRequestForm.valid || (this.id == null && selectedFiles.length === 0)">
        Guardar
      </button>
    </mat-dialog-actions>
  </ng-template>

  <ng-template #deleteDialog let-data>
    <div class="flex items-start space-x-2 mb-4">
      <div class="flex items-center">
        <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
          style="font-size: 32px;"></mat-icon>
      </div>
      <div class="grid">
        <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
        <mat-dialog-content class="modal-content mt-0">
          <p>¿Está seguro que desea eliminar el registro?</p>
        </mat-dialog-content>
      </div>
    </div>
    <mat-dialog-actions class="modal-actions flex justify-end">
      <button mat-button mat-dialog-close class="align-left">Conservar</button>
      <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
    </mat-dialog-actions>
  </ng-template>

  <ng-template #imageGalleryModal>
  <div class="flex items-center justify-between">
    <h2 mat-dialog-title class="text-lg font-bold">
      Galería de Imágenes ({{ currentAttachments.length }})
    </h2>
    <div class="flex items-center mr-4">
      <mat-icon
        svgIcon="heroicons_outline:x-circle"
        matTooltip="Cerrar"
        class="cursor-pointer"
        mat-dialog-close
      ></mat-icon>
    </div>
  </div>

  <mat-dialog-content
    class="modal-content !pt-0 overflow-hidden"
    style="max-height: none; padding-bottom: 1rem;"
  >
    <div class="p-4" *ngIf="currentAttachments.length > 0">
      <div
        class="w-full mb-4 border rounded-lg overflow-hidden shadow-lg flex justify-center items-center"
        style="max-height: 45vh;"
      >
        <img
          [src]="currentImageLink"
          [alt]="currentAttachments[currentImageIndex]?.name || 'Imagen'"
          class="max-h-[40vh] object-contain mx-auto block"
        />
      </div>

      <div class="flex overflow-x-auto space-x-2 pb-2 justify-center">
        <div *ngFor="let img of currentAttachments; let i = index" class="flex-shrink-0">
          <img
            [src]="img.link"
            [alt]="img.name"
            (click)="setMainImage(i)"
            class="w-20 h-20 object-cover rounded cursor-pointer border-2 transition-all duration-150"
            [ngClass]="{
              'border-blue-500 ring-2 ring-blue-300': i === currentImageIndex,
              'border-gray-300 hover:border-blue-400': i !== currentImageIndex
            }"
          />
        </div>
      </div>
    </div>

    <div *ngIf="currentAttachments.length === 0" class="flex justify-center items-center h-32">
      <p class="text-gray-500 m-0">No hay imágenes adjuntas</p>
    </div>
  </mat-dialog-content>
</ng-template>

  <app-filter (onFilterEvent)="getList()" (onCleanEvent)="clearFilters()">
    <app-filter-section title="Rango de fechas" [expanded]="true">
      <app-dates-filters [form]="form" [showDateCreationRange]="true"></app-dates-filters>
    </app-filter-section>

    <app-filter-section title="Gestión de rutas" [expanded]="false" (onExpanded)="onRoutesExpanded()">
      <app-routes-filters [form]="form" [route]="true" [loadData]="loadRoutesData"></app-routes-filters>
    </app-filter-section>

    <app-filter-section title="Socio de negocio" [expanded]="false" (onExpanded)="onBusinessPartnersExpanded()">
      <app-business-partners-filters [form]="form" [businessPartner]="true" [assignedUser]="true"
        [loadData]="loadBusinessPartnersData"></app-business-partners-filters>
    </app-filter-section>
  </app-filter>
</mat-sidenav-container>